import { Component, OnInit } from '@angular/core';
import { HammaddeService } from '../_services/hammadde.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AddallergenComponent } from './addallergen/addallergen.component';

@Component({
  selector: 'app-allergen',
  templateUrl: './allergen.component.html',
  styleUrls: ['./allergen.component.css']
})
export class AllergenComponent implements OnInit {

  hammeddeler:any[]=[];
  filteredhammeddeler:any[]=[];
  page=1;
  constructor(
    private hammaddeService:HammaddeService,
    private modal:NgbModal,
    private toastr: ToastrService) { }
  @BlockUI('changelog') blockUIChangelog: NgBlockUI;
  ngOnInit() {
    this.getHammaddeler (this.page);
  }


  getHammaddeler(page:number){
    this.blockUIChangelog.start('Loading..');
    this.hammaddeService.getAllergens().subscribe(res=>{
      this.hammeddeler=res;
      this.filteredhammeddeler=res;
      this.blockUIChangelog.stop();
    },err=>{
      this.blockUIChangelog.stop();
    });
  }

  openSaveModal(){
    const modalref=  this.modal.open(AddallergenComponent, { size: 'xl' });
   
    modalref.result.then((result)=>{
     this.getHammaddeler(this.page);
    });
    }

 


    delete(id){
        this.hammaddeService.removeAllergens(id).subscribe(res=>{
          this.getHammaddeler(this.page);
          this.toastr.success('', 'Kayıt silindi');
        });
    }

    prevPage(){
      if(this.page>1){
        this.page--;
        this.getHammaddeler(this.page);
      }
     
    }
    nextPage(){
      this.page++;
      this.getHammaddeler(this.page);
    }

    search(data:any){
      console.log(data.target.value);
        if(data.target.value.length<3){
          this.filteredhammeddeler=this.hammeddeler;
        }
        else{


        this.hammaddeService.search(data.target.value,1).subscribe(res=>{
          this.filteredhammeddeler=res;
        });
        }
    }
}
